import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "product-info-card__header" }
const _hoisted_2 = { class: "product-info-card__inner" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "left col-4"
}
const _hoisted_5 = { class: "product-info-card__image" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "bold" }
const _hoisted_8 = { class: "row bottom space-v2" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "italic" }
const _hoisted_11 = ["onKeydown"]
const _hoisted_12 = {
  key: 0,
  class: "product-info-card__inner"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "location-id" }
const _hoisted_15 = { class: "bold" }
const _hoisted_16 = { class: "storage-location-id" }
const _hoisted_17 = { class: "medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: $setup.showModal,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.showModal) = $event))
  }, {
    default: _withCtx(() => [
      (!$setup.scannedResult?.length)
        ? (_openBlock(), _createBlock(_component_q_card, {
            key: 0,
            class: "product-info-card"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("section", { class: "product-info-card__header" }, [
                _createElementVNode("h5", null, "No Products to display")
              ], -1)
            ])),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_q_card, {
            key: 1,
            class: "product-info-card"
          }, {
            default: _withCtx(() => [
              _createElementVNode("section", _hoisted_1, [
                _createElementVNode("h5", null, _toDisplayString($setup.scannedResult?.length === 1 ? `${$setup.scannedResult?.[0].sys?.type === 'stock' ? 'Stock Item' : 'Product'} found` : `Found ${$setup.scannedResult?.length} ${$setup.scannedResult?.[0].sys?.type === 'stock' ? 'Stock Items' : 'Products'}`), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.scannedResult, (item) => {
                return (_openBlock(), _createElementBlock("section", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    (item.images?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("img", {
                              src: item.images[0]?.file
                            }, null, 8, _hoisted_6)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["right", {'col-8': item.images?.length > 0, 'col-12': item.images?.length <= 0}])
                    }, [
                      _createElementVNode("h3", _hoisted_7, _toDisplayString(item.title), 1)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h4", null, [
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "medium" }, "EAN  ", -1)),
                        _createElementVNode("span", null, _toDisplayString(!item.ean ? '-' : item.ean?.join(', ')), 1)
                      ]),
                      _createElementVNode("h4", _hoisted_10, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "medium" }, "SKU  ", -1)),
                        _createElementVNode("span", null, _toDisplayString(item.sku || '-'), 1)
                      ])
                    ])
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "hidden-scan-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.hiddenScanInput) = $event)),
                    autofocus: "",
                    onKeydown: _withKeys(($event: any) => ($setup.navigateToProduct(item)), ["enter"])
                  }, null, 40, _hoisted_11), [
                    [_vModelText, $setup.hiddenScanInput]
                  ]),
                  _withDirectives(_createVNode(_component_q_btn, {
                    class: "product-info-card__button-view",
                    color: "primary",
                    unelevated: "",
                    rounded: "",
                    onClick: ($event: any) => ($setup.navigateToProduct(item)),
                    label: "View details"
                  }, null, 8, ["onClick"]), [
                    [_vShow, item?.sys?.type === 'product']
                  ])
                ]))
              }), 256)),
              ($setup.relatedLocations?.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                    _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
                    _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "bold" }, "Inventory Locations", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.relatedLocations, (loc) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "row locations-list",
                        onClick: ($event: any) => ($setup.navigateToLocation(loc))
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("h5", null, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(loc.id), 1),
                            _createElementVNode("span", null, "    " + _toDisplayString(loc.count ?? '-'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("h6", _hoisted_17, _toDisplayString(loc.storage_location?.id), 1)
                        ])
                      ], 8, _hoisted_13))
                    }), 256))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}